import styled from 'styled-components';

export const Wrap = styled.div<{ $disabled: boolean }>`
  margin-top: 50px;
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: -10px !important;
  cursor: pointer;
  user-select: none;
  width: fit-content;
  justify-self: flex-start;
  align-self: flex-start;

  cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
`;
